import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {Link} from 'react-router-dom';
import {ContentStyled} from '../../styles/components/content.style';
import {DEFAULT_HEADER_COLOR} from '../../constants/constant';

export const Wrapper = styled.div`
  max-width: ${props => props.theme.container.wider.width};
  margin: 0 auto;
`;

export const PanelWrapper = ContentStyled.extend`
  background: ${props => props.theme.homePage.background};
  text-align: center;
  padding: ${props => props.theme.homePage.padding};
  max-width: ${props => props.theme.homePage.width};
  margin-top: ${props => props.theme.homePage.offsetTop};
  color: ${props => props.theme.homePage.color};
  ${media.medium`
    max-width: 100%;
    margin: ${props => props.getInTouchPanel ? 0 : props.theme.homePage.mobile.margin};
  `};
`;

export const PanelHeader = styled.h2`
  font-size: ${props => props.theme.homePage.header.fontSize};
  border-bottom: ${props => props.theme.homePage.border};
  padding: ${props => props.theme.homePage.header.padding};
  color: ${props => props.headerColor};
  width: 100%;
  margin: 0;
`;

export const ButtonColorWrapper = styled.div`
  background-color: ${props => props.headerColor};
  border-radius: ${props => props.theme.homePage.panelContent.button.radius};
  max-width: ${props => props.theme.homePage.panelContent.button.width};
  margin: ${props => props.theme.homePage.panelContent.button.margin};
`;

export const PanelContent = styled.div`
  padding: ${props => props.theme.padding};
  background-color: ${props => props.theme.homePage.panelContent.background};
`;

export const PanelActions = styled.div`
  padding: ${props => props.theme.padding};
  border-top: ${props => props.theme.homePage.border};
  background-color: ${props => props.theme.homePage.actionPanel.background};
`;

export const ActionButton = styled(Link)`
  text-transform: uppercase;
  display: block;
  color: ${props => props.theme.homePage.panelContent.button.color};
  font-size: ${props => props.theme.homePage.panelContent.button.fontSize};
  margin: ${props => props.theme.homePage.panelContent.button.margin};
  padding: ${props => props.theme.homePage.panelContent.button.padding};
  max-width: ${props => props.theme.homePage.panelContent.button.width};
  border-radius: ${props => props.theme.homePage.panelContent.button.radius};
  &:hover {
    background: ${props => props.theme.homePage.panelContent.button.hoverColor1};
  }
`;

export const ActionButton2 = ActionButton.extend`
  background-color: ${props => props.theme.homePage.panelContent.button.backgroundColor2};
  &:hover {
    background: ${props => props.theme.homePage.panelContent.button.hoverColor2};
  }
`;

export const OrderNow = styled(Link)`
  color: ${props => props.theme.orderNow.color};
  text-transform: uppercase;
  text-align: center;
  transition: background-color 0.2s;
  display: block;
  line-height: ${props => props.theme.orderNow.lineHeight};
  padding: ${props => props.theme.orderNow.padding};
  background: ${props => props.theme.orderNow.backgroundColor};
  font-size: ${props => props.theme.orderNow.fontSize};
  margin: ${props => props.theme.orderNow.margin};
  &:hover {
    background: ${props => props.theme.orderNow.hoverColor};
    color: ${props => props.theme.linkColor};
  }
  &::before {
    font-family: 'icomoon';
    content: '\\f07a';
    font-size: ${props => props.theme.orderNow.iconSize};
    margin-right: ${props => props.theme.margin};
    color: ${props => props.theme.secondaryColor};
  }
  span {
    color: ${props => props.theme.orderNow.color};
  }
`;

export const Logo = styled.img`
  max-width: 100%;
  max-height: 24rem;
`;

export const TradeShowLogo = Logo.extend`
  border: 1px solid #eeebeb;
  border-radius: 0.6rem;
  margin-top: -7rem;
  background-color: #fff;
`;
export const Address = styled.span`
  display: block;
  letter-spacing: 0.1rem;
`;

export const RestaurantName = styled.h1`
  font-size: ${props => props.theme.homePage.title.fontSize};
  font-weight: ${props => props.theme.homePage.title.fontWeight};
  color: ${props => props.headerColor};
  padding-top: 0.8rem;
  padding-left: ${props => props.theme.padding};
  padding-right: ${props => props.theme.padding};
  padding-bottom: ${props => props.theme.padding};
  margin: 0;
`;

export const SmallAddress = Address.extend`
  font-size: 1.2rem;
  padding-bottom: ${props => props.theme.padding};
  line-height: 1.6rem;
  font-style: italic;
`;

export const SmallAddressWrapper = styled.span`
  color: ${props => props.headerColor && props.headerColor !== DEFAULT_HEADER_COLOR ? props.headerColor : props.theme.homePage.linkColor};
`;

export const SmallAddressLink = styled(Link)`
  font-size: 1.2rem;
  display: block;
  line-height: 1.6rem;
  color: inherit;
  padding-bottom: ${props => props.theme.padding};
`;

export const ContactNumber = styled.a`
  color: ${props => props.headerColor && props.headerColor !== DEFAULT_HEADER_COLOR ? props.headerColor : props.theme.homePage.linkColor};
  padding-left: ${props => props.theme.homePage.contact.padding};
`;

export const ParsedContent = styled.div`
  background-color: ${props => props.theme.homePage.parsedContent.background};
  font-size: ${props => props.theme.homePage.parsedContent.fontSize};
  padding: ${props => props.theme.homePage.parsedContent.padding};
  a {
    color: ${props => props.headerColor && props.headerColor !== DEFAULT_HEADER_COLOR ? props.headerColor : props.theme.homePage.linkColor};
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: Lato, Helvetica, Arial, sans-serif;
  }
  h1 {
    font-size: ${props => props.theme.homePage.title.fontSize};
    font-weight: ${props => props.theme.homePage.title.fontWeight};
  }
  h2 {
    font-size: ${props => props.theme.homePage.header.fontSize};
  }
  p {
    font-family: 'Droid Serif', Georgia, 'Times New Roman', serif;
  }
  img {
    max-width: 100%;
  }
`;

export const RestaurantPanelStyled = styled.div`
  width: 32rem;
  text-align: center;
  position: fixed;
  top: 9rem;
  margin-left: 2.4rem;
  background: ${props => props.theme.homePage.actionPanel.background};
  color: ${props => props.theme.homePage.color};
  padding: ${props => props.theme.homePage.padding};
  ${media.small`
    width: 100%;
    position: relative;
    margin-left: 0;
    left: 0;
    top: 0;
  `};
`;

export const MapWrapper = styled(Link)`
  position: relative;
  max-width: 100%;
  overflow: hidden;
  outline: none;
  display: block;
  cursor: pointer;
`;

export const OpeningStatus = styled.div`
  width: 10rem;
  padding: 0.6rem 0;
  margin: 0 -5rem;
  position: absolute;
  top: 35%;
  left: 50%;
  text-align: center;
  border-radius: 4rem;
  color: ${props => props.isOpen ? props.headerColor : props.theme.primaryColor};
  background-color: ${props => props.isOpen ? props.theme.primaryBackground : props.theme.quaternaryBackground};
`;

export const StaticMap = styled.img`
  width: 100%;
  min-height: 13rem;
`;

export const Container = styled.div`
  margin: ${props => props.theme.homePage.container.margin};
  ${media.small`
    margin: 0;
  `};
`;



// WEBPACK FOOTER //
// ./containers/HomePage/HomePage.style.js